<div class="modal-header b pb-0 pt-3">
  <p class="modal-title font-weight-600" id="createnote">{{ !TalentpoolIDtoEdit ? 'Create Talent pool' : 'Edit Talentpool' }}</p>
  <button data-testid="auto-app-create-talentpool-button-1" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
    (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body px-3 pb-0">
  <form [formGroup]="talentpool_form">
    <div class="mb-4">
      <label for="Notes" class="f-14 font-weight-normal"> Talent pool Name <span class="text-danger">*</span></label>
      <div class="position-relative ">
        <input data-testid="auto-app-create-talentpool-input-1" type="text" placeholder="Enter Talentpool Name" class="wc-textarea wc-form-control mb-3px"
          formControlName="talentpoolname">
      </div>
      <p class="f-12 font-weight-500"
        *ngIf="talentpool_form.get('talentpoolname').errors?.required && (talentpool_form['controls'].talentpoolname.dirty || talentpool_form['controls'].talentpoolname.touched)"
        [ngClass]="['text-left','my-1','text-danger']">Talentpool Name is required</p>
        <p *ngIf="talentpool_form['controls'].talentpoolname.hasError('pattern')" class="text-danger f-12 pt-1">
          HTML tags are not allowed</p>
    </div>

    <div class="">
      <label for="Notes" class="f-14 font-weight-normal"> Talent pool Description
        <!-- <span class="text-danger">*</span> -->
      </label>
      <div class="position-relative ">
        <textarea data-testid="auto-app-create-talentpool-textarea-1" type="text" placeholder="Enter Talentpool Description" class="wc-textarea wc-form-control"
          formControlName="talentpooldescription" rows="6">
          </textarea>
      </div>
      <!-- <p class="f-12 font-weight-500" *ngIf="talentpool_form.get('talentpooldescription').errors?.required && (talentpool_form['controls'].talentpooldescription.dirty
      || talentpool_form['controls'].talentpooldescription.touched)" [ngClass]="['text-left','my-1','text-danger']">
        Talentpool Description is required</p> -->
        <p *ngIf="talentpool_form['controls'].talentpooldescription.hasError('pattern')" class="text-danger f-12 pt-1">
          HTML tags are not allowed</p>
    </div>

  </form>

</div>
<div class="modal-footer b pb-3">
  <button data-testid="auto-app-create-talentpool-button-2" type="button" class="btn-trms-small" data-dismiss="modal"
    (click)="createTalentpool()"> {{ !TalentpoolIDtoEdit ? 'Save' : 'Save Changes' }}</button>
</div>

<ng-template #errorModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-create-talentpool-button-3" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-create-talentpool-button-4" class="btn-trms-small" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-create-talentpool-button-5" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">CONGRATULATIONS !!!</p>
          <p class="text-center">{{success_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-create-talentpool-button-6" class="btn-trms-white" (click)="modalService.dismissAll()">CANCEL</button>
          <button data-testid="auto-app-create-talentpool-button-7" class="btn-trms-small" (click)="modalService.dismissAll()">DONE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
